mapboxgl.accessToken = 'pk.eyJ1IjoibWFwYm94c291bG9yaWdpbiIsImEiOiJjbWYzOTBhYW4wOXR1MnFxNXJrbDFqYjRxIn0.muIlWAt-du6TIKqVxWAbaw';

/**
 * Add the map to the page
 */
const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/streets-v11',
  center: [133.37753877679097, -25.977297572783417],
  zoom: 3,
  scrollZoom: true,
});

// const stores - defined in store-locator.liquid to use article metafields and be defined first
/**
 * Assign a unique id to each store. You'll use this `id`
 * later to associate each point on the map with a listing
 * in the sidebar.
 */
stores.features.forEach((store, i) => {
  store.properties.id = i;
});

/**
 * Wait until the map loads to make changes to the map.
 */
map.on('load', async () => {
  /**
   * This is where your '.addLayer()' used to be, instead
   * add only the source without styling a layer
   */

  map.addSource('places', {
    type: 'geojson',
    data: stores,
  });

  /**
   * Create a new MapboxGeocoder instance.
   */
  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    autocomplete: false,
    mapboxgl: mapboxgl,
    marker: true,
    bbox: [113.56979229907121, -41.584481052323, 154.39465662095077, -14.934727932306428],
  });

  /**
   * Add all the things to the page:
   * - The location listings on the side of the page
   * - The search box (MapboxGeocoder) onto the map
   * - The markers onto the map
   */
  buildLocationList(stores);
  document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

  addMarkers();

  /**
   * Listen for when a geocoder result is returned. When one is returned:
   * - Calculate distances
   * - Sort stores by distance
   * - Rebuild the listings
   * - Adjust the map camera
   * - Open a popup for the closest store
   * - Highlight the listing for the closest store.
   */
  geocoder.on('result', (event) => {
    /* Get the coordinate of the search result */
    const searchResult = event.result.geometry;
    /**
     * Calculate distances:
     * For each store, use turf.disance to calculate the distance
     * in miles between the searchResult and the store. Assign the
     * calculated value to a property called `distance`.
     */
    const options = { units: 'miles' };
    for (const store of stores.features) {
      store.properties.distance = turf.distance(searchResult, store.geometry, options);
    }

    /**
     * Sort stores by distance from closest to the `searchResult`
     * to furthest.
     */
    stores.features.sort((a, b) => {
      if (a.properties.distance > b.properties.distance) {
        return 1;
      }
      if (a.properties.distance < b.properties.distance) {
        return -1;
      }
      return 0; // a must be equal to b
    });

    /**
     * Rebuild the listings:
     * Remove the existing listings and build the location
     * list again using the newly sorted stores.
     */
    // const listings = document.getElementById('listings');
    // while (listings.firstChild) {
    //   listings.removeChild(listings.firstChild);
    // }

    stores;

    /* Open a popup for the closest store. */
    createPopUp(stores.features[0]);

    /** Highlight the listing for the closest store. */
    const activeListing = document.getElementById(`listing-${stores.features[0].properties.id}`);
    activeListing && activeListing.classList.add('active');

    /**
     * Adjust the map camera:
     * Get a bbox that contains both the geocoder result and
     * the closest store. Fit the bounds to that bbox.
     */
    const bbox = getBbox(stores, 0, searchResult);
    map.fitBounds(bbox, {
      padding: 100,
    });
  });
});

/**
 * Using the coordinates (lng, lat) for
 * (1) the search result and
 * (2) the closest store
 * construct a bbox that will contain both points
 */
function getBbox(sortedStores, storeIdentifier, searchResult) {
  const lats = [sortedStores.features[storeIdentifier].geometry.coordinates[1], searchResult.coordinates[1]];
  const lons = [sortedStores.features[storeIdentifier].geometry.coordinates[0], searchResult.coordinates[0]];
  const sortedLons = lons.sort((a, b) => {
    if (a > b) {
      return 1;
    }
    if (a.distance < b.distance) {
      return -1;
    }
    return 0;
  });
  const sortedLats = lats.sort((a, b) => {
    if (a > b) {
      return 1;
    }
    if (a.distance < b.distance) {
      return -1;
    }
    return 0;
  });
  return [
    [sortedLons[0], sortedLats[0]],
    [sortedLons[1], sortedLats[1]],
  ];
}

/**
 * Add a marker to the map for every store listing.
 **/
function addMarkers() {
  /* For each feature in the GeoJSON object above: */
  for (const marker of stores.features) {
    if (marker.geometry.coordinates[0]) {
      /* Create a div element for the marker. */
      const el = document.createElement('div');
      /* Assign a unique `id` to the marker. */
      el.id = `marker-${marker.properties.id}`;
      /* Assign the `marker` class to each marker for styling. */
      el.className = 'marker';

      /**
       * Create a marker using the div element
       * defined above and add it to the map.
       **/
      new mapboxgl.Marker(el, { offset: [0, -23] }).setLngLat(marker.geometry.coordinates).addTo(map);

      /**
       * Listen to the element and when it is clicked, do three things:
       * 1. Fly to the point
       * 2. Close all other popups and display popup for clicked store
       * 3. Highlight listing in sidebar (and remove highlight for all other listings)
       **/
      el.addEventListener('click', (e) => {
        flyToStore(marker);
        createPopUp(marker);
        const activeItem = document.getElementsByClassName('active');
        e.stopPropagation();
        if (activeItem[0]) {
          activeItem[0].classList.remove('active');
        }
        const listing = document.getElementById(`listing-${marker.properties.id}`);
        listing.classList.add('active');
      });
    }
  }
}

/**
 * Add a listing for each store to the sidebar.
 **/
function buildLocationList(stores) {
  for (const store of stores.features) {
    if (store.geometry.coordinates[0]) {
      /* Add a new listing section to the sidebar. */
      const listings = document.getElementById('listings');
      const listing = listings.appendChild(document.createElement('div'));
      /* Assign a unique `id` to the listing. */
      listing.id = `listing-${store.properties.id}`;
      /* Assign the `item` class to each listing for styling. */
      listing.className = `item ${store.properties.storeState}`;

      /* Add the link to the individual listing created above. */
      const link = listing.appendChild(document.createElement('a'));
      link.className = 'title';
      link.id = `link-${store.properties.id}`;
      link.innerHTML = `${store.properties.storeName} - ${store.properties.price}`;
      /* Add Format Name in listing */
      const formatname = listing.appendChild(document.createElement('span'));
      formatname.className = 'format-name';
      formatname.textContent = `${store.properties.format}`;
      /* Add details to the individual listing. */
      const details = listing.appendChild(document.createElement('div'));
      if (store.properties.address) {
        details.innerHTML += `${store.properties.address}`;
      }
      if (store.properties.distance) {
        const roundedDistance = Math.round(store.properties.distance * 100 * 1.60934) / 100;
        details.innerHTML += `<div><strong>${roundedDistance} km away</strong></div>`;
      }

      /* removing turnover and foot traffic for now
      const customcontainer =  listing.appendChild(document.createElement('div'));
      customcontainer.className = 'custom-field-container'
      if(store.properties.centreTurnover) {
        const centreturnover = customcontainer.appendChild(document.createElement('div'));
        centreturnover.className = 'centre-turn-over';
        centreturnover.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0656/0507/5176/files/CompositeLayer_17.png?v=1698743677" width="25" height="25" alt="Centre Turnover" /><span class="title">${store.properties.centreTurnover}</span>`;
      }
      if(store.properties.annualFootTraffic) {
        const annualfoottraffic = customcontainer.appendChild(document.createElement('div'));
        annualfoottraffic.className = 'annual-foot-traffic';
        annualfoottraffic.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0656/0507/5176/files/CompositeLayer_18.png?v=1698743730" width="25" height="25" alt="Annual Foot Traffic" /><span class="title">${store.properties.annualFootTraffic}</span>`;
      }
       */
      /* Add details to the individual listing. */
      // details.innerHTML += `<a class="info" href="${store.properties.articleUrl}">More information</a>`

      /**
       * Listen to the element and when it is clicked, do four things:
       * 1. Update the `currentFeature` to the store associated with the clicked link
       * 2. Fly to the point
       * 3. Close all other popups and display popup for clicked store
       * 4. Highlight listing in sidebar (and remove highlight for all other listings)
       **/
      link.addEventListener('click', function () {
        for (const feature of stores.features) {
          if (this.id === `link-${feature.properties.id}`) {
            flyToStore(feature);
            createPopUp(feature);
          }
        }
        const activeItem = document.getElementsByClassName('active');
        if (activeItem[0]) {
          activeItem[0].classList.remove('active');
        }
        this.parentNode.classList.add('active');
      });
    }
  }
}

/**
 * Use Mapbox GL JS's `flyTo` to move the camera smoothly
 * a given center point.
 **/
function flyToStore(currentFeature) {
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: 10,
  });
}

/**
 * Create a Mapbox GL JS `Popup`.
 **/
function createPopUp(currentFeature) {
  const popUps = document.getElementsByClassName('mapboxgl-popup');
  if (popUps[0]) popUps[0].remove();

  if (currentFeature.geometry.coordinates[0]) {
    const popup = new mapboxgl.Popup({ closeOnClick: true })
      .setLngLat(currentFeature.geometry.coordinates)
      .setHTML(
        `
      <img class="tooltip_green_dot" src="https://cdn.shopify.com/s/files/1/0656/0507/5176/files/tooltip-green.png?v=1666741623">
      <div class="franchise_tooltip">
        <div class="franchise_tooltip_details">
          <h3 class="franchise_tooltip_title">${currentFeature.properties.storeName}</h3>
          <div>Store Format: ${currentFeature.properties.format}</div>
          <div>Address: ${currentFeature.properties.address}</div>
          <div>Investment: ${currentFeature.properties.price}</div>
          <div id="modal-opener--${currentFeature.properties.handle}" class="map_modal_opener link">Learn more</div>
          <div id="modal--${currentFeature.properties.handle}" class="map_modal">
          <div class="map_modal_content product-popup-modal__content">
            <button id="modal-close--${currentFeature.properties.handle}" class="map_modal_close product-popup-modal__toggle">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
              </svg>
            </button>
            <div class="map_modal_flexbox">
              <div class="map_modal_col map_modal_col_1">
                <h2 class="map_modal_title h1">${currentFeature.properties.storeName}</h2>
                <h3 class="h2">LOCATION WEBSITE:</h3> 
                <a href="${currentFeature.properties.website}">${currentFeature.properties.website}</a>
                <h3 class="h2">LOCATION DESCRIPTION:</h3>
                <p>${currentFeature.properties.description}</p>
                  <a href="/pages/franchise-contact?location="${currentFeature.properties.handle}" class="product-popup-modal__button link  button button--primary" type="button" aria-haspopup="dialog">
                    Enquire now
                    <svg xmlns="http://www.w3.org/2000/svg" style="margin-left:5px;" width="30" height="30" viewBox="0 0 48 51">
                      <text id="_" data-name="→" font-size="43" font-family="LucidaGrande, Lucida Grande"><tspan x="0" y="42">→</tspan></text>
                    </svg>
                  </a>
              </div>
              <div class="map_modal_col map_modal_col_2">
                <h3>ADDRESS:</h3>
                <p>${currentFeature.properties.address}</p>
                <h3>PRICE:</h3>
                <p>${currentFeature.properties.price}</p>
                <h3>FORMAT:</h3>
                <p>${currentFeature.properties.format}</p>
                <img style="height: 50%" src="${currentFeature.properties.image}">
              </div>
            </div>  
          </div>
        </div>
        </div>
        <modal-opener data-modal="#PopupModal-ImageBanner">
          <button class="product-popup-modal__button link  button button--primary" type="button" aria-haspopup="dialog">
            Enquire now
            <svg xmlns="http://www.w3.org/2000/svg" style="margin-left:5px;" width="30" height="30" viewBox="0 0 48 51">
              <text id="_" data-name="→" font-size="43" font-family="LucidaGrande, Lucida Grande"><tspan x="0" y="42">→</tspan></text>
            </svg>
          </button>
        </modal-opener>

      </div>
      `
      )
      .addTo(map);
  }
}
